import React from 'react';
import Plot from 'react-plotly.js';
import { LineChartProps } from './ChartInterfaces';

const LineChart: React.FC<LineChartProps> = ({ 
  data, 
  title = 'Line Chart', 
  xAxisLabel, 
  yAxisLabel, 
  showLegend = false,
  lineColor = 'blue' 
}) => {
  // Handle both single line and multiple line data
  const traces = Array.isArray(data.yValues) && data.yValues.length > 0 && typeof data.yValues[0] === 'object' && 'name' in data.yValues[0]
    ? (data.yValues as Array<{ name: string; values: number[] }>).map((line, index) => ({
        x: data.xValues,
        y: line.values,
        name: line.name,
        type: 'scatter' as const,
        mode: 'lines+markers' as const,
        marker: { color: ['blue', 'red', 'green', 'purple'][index % 4] },
        line: { shape: 'spline' as const }
      }))
    : [{
        x: data.xValues,
        y: data.yValues as number[],
        type: 'scatter' as const,
        mode: 'lines+markers' as const,
        marker: { color: lineColor },
        line: { shape: 'spline' as const }
      }];

  return (
    <Plot
      data={traces}
      layout={{
        title,
        xaxis: { title: xAxisLabel },
        yaxis: { title: yAxisLabel },
        margin: { t: 50, b: 40, l: 50, r: 10 },
        showlegend: showLegend,
      }}
      config={{responsive: true}}
      className="w-full h-full"
    />
  );
};

export default LineChart;